/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PleaseWait/view.blocks to change it.
import Info from 'DesignSystem/Info/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function PleaseWait({
  children,
  viewPath = "/App/Auth/SignUpConfirm/Content/OtherContactMethods/PleaseWait"
  
}) {
  return (<React.Fragment
>
<Info
  viewPath={`${viewPath}/Info`}
 marginLeft={10}
 text="Wait a bit"
/>
{children}
</React.Fragment>)
}